import React, { useState } from 'react';
import { Card } from 'antd';
import classnames from 'classnames';
import ArrowDownIcon from '../../../resources/assets/icons/ArrowDownIcon';

export default function CollapsibleForm({ title, defaultShow, children, className }) {
  const [show, setShow] = useState(defaultShow ?? false);
  const toggle = () => setShow((current) => !current);

  return (
    <Card className={className}>
      <div className="flex justify-between">
        <h5 className="my-auto underline">{title}</h5>
        <span onClick={toggle} className={classnames('cursor-pointer p-xs rounded-md', { 'rotate-90': !show })}>
          <ArrowDownIcon />
        </span>
      </div>
      {show && <div>{children}</div>}
    </Card>
  );
}
